import {minmax, sectionToFixedMap, portrait, promo} from '../shared.js';
import {
  buildNarrativeTextTimeline,
  animatePages,
  dashPaths,
} from '../animations.js';

const article = document.querySelector('#chapter15');
const narrativeSection = article.querySelector('#chapter15-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeText = narrativeFixed.querySelector('.narrative-text');
const narrativeTimeline = new TimelineLite({paused: true});

const fullVidSection = article.querySelector('#chapter15-fullvid');

const infographicSection = article.querySelector('#chapter15-infographic');
const infographicFixed = sectionToFixedMap.get(infographicSection);
const pathHighlights = infographicFixed.querySelectorAll('figure svg path');
const infographicText = infographicFixed.querySelector('.narrative-text');
const infographicPages = Array.from(infographicFixed.querySelectorAll('.declassified-page'));
const infographicQuotes = Array.from(infographicFixed.querySelectorAll('.callout'));
const infographicTimeline = new TimelineLite({paused: true});
const footnote = infographicFixed.querySelector('.footnote');

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter15:init');

  initNarrative();
  initFullVideo();
  initInfographic();
}

/**
 * Init the narrative section
 */
function initNarrative() {
  narrativeSection.addEventListener('active', () => promo.classList.add('active'));
  narrativeSection.addEventListener('inactive', () => promo.classList.remove('active'));

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85, 'rgba(0, 0, 0, 0.4)');

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));
}

/**
 * Init the full video section
 */
function initFullVideo() {
  fullVidSection.addEventListener('active', () => promo.classList.add('active'));
  fullVidSection.addEventListener('inactive', () => promo.classList.remove('active'));
}


/**
 * Init the infographic section
 */
function initInfographic() {
  TweenLite.set([...infographicPages, ...infographicQuotes, footnote], {opacity: 0});
  TweenLite.set(infographicPages, {scale: 1.5});

  dashPaths(pathHighlights);

  buildNarrativeTextTimeline(infographicTimeline, infographicText, 100);

  infographicTimeline.to({}, 50, {});

  infographicTimeline.to(footnote, 25, {opacity: 1});

  animatePages(infographicPages, infographicTimeline, !portrait.matches);

  infographicTimeline.to(infographicQuotes, 25, {opacity: 1});

  infographicSection.addEventListener('scrub', ({detail: {vh}}) => infographicTimeline.seek(minmax(0, vh, infographicTimeline.duration())));
}
